import React from 'react';
import SopSidebar from './SopSidebar';
import UserMenu from '../../../components/UserMenu';
import AnnouncementBanner from '../../../components/announcements/AnnouncementBanner';

const SopLayout = ({ children }) => (
  <div className="flex flex-col lg:flex-row h-screen bg-slate-900 overflow-hidden">
    <SopSidebar />
    <div className="flex-1 w-full lg:w-auto lg:ml-64 flex flex-col h-screen overflow-hidden">
      <header className="bg-slate-800 border-slate-700 border-b flex-shrink-0">
        <div className="px-6 py-4 flex justify-between items-center gap-3">
          <h1 className="text-xl font-semibold text-slate-200 ml-12 lg:ml-0 min-w-0 truncate">KSP SOPs</h1>
          <AnnouncementBanner />
          <div className="flex-shrink-0">
            <UserMenu isDarkMode />
          </div>
        </div>
      </header>
      <main className="flex-1 overflow-y-auto text-slate-100">{children}</main>
    </div>
  </div>
);

export default SopLayout;
